import { Messages } from '@Config/messages';
import { RouteConfig } from '@Config/routes';
import lazyImport from '@Utils/lazyImport';
import { authenticatedOnlyComponent } from '@Utils/router';

import { RouteInfo } from '../appRoutes';

// @NOTE: AdvertPage causes `Uncaught TypeError: error loading dynamically imported module`
// when opening in development with Firefox 111.0.1. FF Dev edition and other browsers work fine.
const AdvertPage = lazyImport(() => import('./AdPage'));
const CreateAdPage = lazyImport(() => import('./CreateAdPage'));
const MyAdvertAvailability = lazyImport(() => import('./MyAdvertAvailability'));
const MyAdvertEdit = lazyImport(() => import('./MyAdvertEdit/MyAdvertEdit'));
const MyAdvertsList = lazyImport(() => import('./MyAdvertsList/MyAdvertsList'));
const MyFavoriteAds = lazyImport(() => import('./MyFavoriteAds'));
const BulkUpload = lazyImport(() => import('./BulkUpload'));

const adsRoutes: RouteInfo[] = [
  {
    path: RouteConfig.Advert.template,
    component: AdvertPage,
    title: Messages.advertPageTitle,
    exact: false,
  },

  {
    path: RouteConfig.AdvertNew.template,
    component: authenticatedOnlyComponent(CreateAdPage),
    title: Messages.newAdPage,
  },
  {
    path: RouteConfig.FavoriteAdverts.template,
    component: authenticatedOnlyComponent(MyFavoriteAds),
    title: Messages.myFavourites,
  },

  {
    path: RouteConfig.MyAdverts.template,
    component: authenticatedOnlyComponent(MyAdvertsList),
    title: Messages.companyAdsPage,
  },
  {
    path: RouteConfig.AdvertEdit.template,
    component: authenticatedOnlyComponent(MyAdvertEdit),
    title: Messages.companyAdsPage,
  },
  {
    path: RouteConfig.AdvertAvailability.template,
    component: authenticatedOnlyComponent(MyAdvertAvailability),
    title: Messages.myAdsAvailabilityPage,
  },
  {
    path: RouteConfig.BulkAdvertsUpload.template,
    component: authenticatedOnlyComponent(BulkUpload),
    title: Messages.bulkAdvertsUploadPage,
  },
];

export default adsRoutes;
